<ng-container *ngTemplateOutlet="!authService.isLoggedIn() ? loginButton : launchscope"></ng-container>

<ng-template #loginButton>
    <riege-card
        [data]="cards[0]"
        class="full-width"
        [classes]="['centered']"
        [ngClass]="{
            'login': true,
            'scope-card': true,
            'support-cards': !showCommunityMap,
            }">
        <ng-container action-slot>
            <button
                class="riege-button"
                mat-flat-button
                color="primary"
                action-slot
                data-testid="btn-login"
                [disabled]="authService.loginDisabled()"
                debounceClick
                (doClick)="login()"
                [debounceTime]="700"
                i18n="@@button-label-login"
                >Log in</button
            >
        </ng-container>
    </riege-card>
</ng-template>

<ng-template #launchscope>
    <riege-card
        [data]="cards[1]"
        [classes]="['centered']"
        [ngClass]="{
            'scope-card': true,
            'support-cards':  !showCommunityMap
            }">
        <ng-container action-slot>
            <mat-form-field color="accent" *ngIf="servers.length > 1">
                <mat-label>Server</mat-label>
                <mat-select [(value)]="selectedServer">
                    <mat-option *ngFor="let server of servers" [value]="server"> {{ server.scopeDomain}} </mat-option>
                </mat-select>
            </mat-form-field>

            <button
                class="riege-button"
                mat-flat-button
                color="primary"
                data-testid="btn-launch-scope"
                [disabled]="!selectedServer"
                (click)="launchScope()"
                i18n="@@button-label-launch-app"
                >Launch app</button
            >
        </ng-container>
    </riege-card>
</ng-template>
